import React from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationAccountsBrowse from "./ApplicationAccountsBrowse";
import ApplicationHeader from "../application/ApplicationHeader";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});
const ManageApplicationAccounts = () => {
  return (
    <Container id="manage-application-accounts" disableGutters>
      <ApplicationHeader />

      <ApplicationPanel>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />

          <ApplicationAccountsBrowse />
        </QueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageApplicationAccounts;
